import { createStyles } from "@material-ui/core";
export const useStyles = (theme) =>
  createStyles({
    backStep: {
      // backgroundColor: "#ffffff",
      width: "30px",
      height: "30px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // padding: theme.spacing(1),
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#d4d3d3",
      },
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(0, 3, 0, 0),
      },
      [theme.breakpoints.up("sm")]: {
        margin: theme.spacing(0),
      },
      [theme.breakpoints.up("md")]: {
        margin: theme.spacing(0),
        padding: theme.spacing(1),
      },
    },
    colorDark: {
      color: "#000000",
    },
    colorLight: {
      color: "#ffffff",
    },
    headerText: {
      flexGrow: 1,
      fontWeight: "bold",
    },
    headerBox: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      backgroundColor: "#FFF0F0",
      borderRadius: "20px",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2, 3, 0),
        margin: theme.spacing(2, 2, 2, 2),
        textAlign: "left",
        width: "auto",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2, 3, 1),
        margin: theme.spacing(2, 2, 2, 2),
        textAlign: "center",
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        // padding: theme.spacing(3, 10, 1),
        padding: theme.spacing(2, 10, 1),
        textAlign: "center",
        width: "100%",
        // maxWidth: '184vh',
      },
    },
    headerBoxContainer: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
    },
    headerTitle: {
      flexGrow: 1,
      display: "flex",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
        alignItems: "center",
        textAlign: "center",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        alignItems: "center",
        textAlign: "center",
      },
    },
    bgColorDark: {
      backgroundColor: "#3c63fc",
    },
    bgColorLight: {
      backgroundColor: "#FFF0F0",
    },
  });
